import React from 'react';
import styles from './pagination.module.css';
import { PaginationProps } from '../../../types';
import { useTranslation } from 'react-i18next';

export const Pagination: React.FC<PaginationProps> = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  onItemsPerPageChange,
}) => {
  const { t } = useTranslation();
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(startItem + itemsPerPage - 1, totalItems);
  const pageItems = [15, 30, 50, 100];

  return (
    <div className={styles.paginationContainer}>
      <div className={styles.itemsPerPage}>
        <select
          value={itemsPerPage}
          onChange={(e) =>
            onItemsPerPageChange ? onItemsPerPageChange(Number(e.target.value)) : undefined
          }
          className={styles.select}
        >
          {pageItems.map((size) => (
            <option
              key={size}
              value={size}
            >
              {size}
            </option>
          ))}
        </select>
        <span>{t('itemsPerPage')}</span>
      </div>

      <div className={styles.pageInfo}>
        <span>
          {t('xOfxItems', {
            count: totalItems === 0 ? totalItems : startItem,
            endItem,
            total: totalItems,
          })}
        </span>
      </div>

      <div className={styles.paginationControls}>
        <select
          className={styles.pageSelector}
          value={currentPage}
          onChange={(e) => onPageChange(Number(e.target.value))}
        >
          {Array.from({ length: totalPages }, (_, index) => (
            <option
              key={index + 1}
              value={index + 1}
            >
              {index + 1}
            </option>
          ))}
        </select>
        <span>{t('ofxPages', { total: totalPages })}</span>

        <button
          className={styles.paginationButton}
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <i className="fas fa-chevron-left"></i>
        </button>
        <button
          className={styles.paginationButton}
          disabled={currentPage === totalPages || !totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  );
};
